import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-998a7a02")

_pushScopeId("data-v-998a7a02")
const _hoisted_1 = { class: "shape-style-panel" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("纯色填充")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("渐变填充")
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { style: {"flex":"1"} }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("线性渐变")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("径向渐变")
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "起点颜色：", -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "终点颜色：", -1)
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { style: {"flex":"2"} }, "渐变角度：", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_Select = _resolveComponent("Select")
  const _component_ColorPicker = _resolveComponent("ColorPicker")
  const _component_ColorButton = _resolveComponent("ColorButton")
  const _component_Popover = _resolveComponent("Popover")
  const _component_Slider = _resolveComponent("Slider")
  const _component_ElementFlip = _resolveComponent("ElementFlip")
  const _component_Divider = _resolveComponent("Divider")
  const _component_ElementOutline = _resolveComponent("ElementOutline")
  const _component_ElementShadow = _resolveComponent("ElementShadow")
  const _component_ElementOpacity = _resolveComponent("ElementOpacity")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Select, {
        style: {"flex":"10"},
        value: _ctx.fillType,
        onChange: _cache[1] || (_cache[1] = value => _ctx.updateFillType(value))
      }, {
        default: _withId(() => [
          _createVNode(_component_SelectOption, { value: "fill" }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_SelectOption, { value: "gradient" }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _hoisted_5,
      (_ctx.fillType === 'fill')
        ? (_openBlock(), _createBlock(_component_Popover, {
            key: 0,
            trigger: "click"
          }, {
            content: _withId(() => [
              _createVNode(_component_ColorPicker, {
                modelValue: _ctx.fill,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = value => _ctx.updateFill(value))
              }, null, 8, ["modelValue"])
            ]),
            default: _withId(() => [
              _createVNode(_component_ColorButton, {
                color: _ctx.fill,
                style: {"flex":"10"}
              }, null, 8, ["color"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_Select, {
            key: 1,
            style: {"flex":"10"},
            value: _ctx.gradient.type,
            onChange: _cache[3] || (_cache[3] = value => _ctx.updateGradient({ type: value }))
          }, {
            default: _withId(() => [
              _createVNode(_component_SelectOption, { value: "linear" }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_SelectOption, { value: "radial" }, {
                default: _withId(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]))
    ]),
    (_ctx.fillType === 'gradient')
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_Popover, { trigger: "click" }, {
              content: _withId(() => [
                _createVNode(_component_ColorPicker, {
                  modelValue: _ctx.gradient.color[0],
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = value => _ctx.updateGradient({ color: [value, _ctx.gradient.color[1]] }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withId(() => [
                _createVNode(_component_ColorButton, {
                  color: _ctx.gradient.color[0],
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_Popover, { trigger: "click" }, {
              content: _withId(() => [
                _createVNode(_component_ColorPicker, {
                  modelValue: _ctx.gradient.color[1],
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = value => _ctx.updateGradient({ color: [_ctx.gradient.color[0], value] }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withId(() => [
                _createVNode(_component_ColorButton, {
                  color: _ctx.gradient.color[1],
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          (_ctx.gradient.type === 'linear')
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Slider, {
                  min: 0,
                  max: 360,
                  step: 15,
                  value: _ctx.gradient.rotate,
                  style: {"flex":"3"},
                  onChange: _cache[6] || (_cache[6] = value => _ctx.updateGradient({ rotate: value }))
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_ElementFlip),
    _createVNode(_component_Divider),
    _createVNode(_component_ElementOutline),
    _createVNode(_component_Divider),
    _createVNode(_component_ElementShadow),
    _createVNode(_component_Divider),
    _createVNode(_component_ElementOpacity)
  ]))
})